export default __webpack_public_path__ + "static/media/marketing.fe36b889.svg";